(function(){
  'use strict';

  function emit(name, detail){
    try{ document.dispatchEvent(new CustomEvent(name, {detail: detail || {}})); }catch(error){}
    try{ window.dataLayer && window.dataLayer.push(Object.assign({event:name.replace(':','_')}, detail || {})); }catch(error){}
  }

  var menu = document.getElementById('HitchMobileMenu');
  var menuButton = document.querySelector('.hitch-menu-button');
  var lastFocus = null;
  function setMenu(open){
    if(!menu || !menuButton) return;
    if(open){
      lastFocus = document.activeElement;
      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden','false');
      menuButton.setAttribute('aria-expanded','true');
      document.body.classList.add('menu-open');
      var focusTarget = menu.querySelector('input, a, button:not([data-menu-close])');
      if(focusTarget) window.setTimeout(function(){ focusTarget.focus(); }, 50);
    }else if(!variants.some(function(availableVariant){ return availableVariant.available; })){
      variantInput.value = '';
      addButton.disabled = true;
      addButton.textContent = 'Sold out';
      if(optionGuidance) optionGuidance.hidden = true;
      if(payment) payment.hidden = true;
      if(stickyButton){ stickyButton.disabled = true; stickyButton.textContent = 'Sold out'; }
      if(stickyMeta) stickyMeta.textContent = 'Currently unavailable';
    }else{
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden','true');
      menuButton.setAttribute('aria-expanded','false');
      document.body.classList.remove('menu-open');
      if(lastFocus && lastFocus.focus) lastFocus.focus();
    }
  }
  if(menuButton) menuButton.addEventListener('click',function(){ setMenu(true); });
  document.querySelectorAll('[data-menu-close]').forEach(function(button){ button.addEventListener('click',function(){ setMenu(false); }); });
  document.addEventListener('keydown',function(event){ if(event.key === 'Escape') setMenu(false); });

  document.querySelectorAll('[data-cart-open]').forEach(function(link){
    link.addEventListener('click',function(event){
      if(window.HitchCartDrawer){ event.preventDefault(); window.HitchCartDrawer.open(); }
    });
  });

  document.querySelectorAll('[data-auto-submit]').forEach(function(select){
    select.addEventListener('change',function(){ if(select.form) select.form.submit(); });
  });

  document.querySelectorAll('[data-product-card]').forEach(function(card){
    card.addEventListener('click',function(event){
      var link = event.target.closest('a');
      if(!link) return;
      emit('hitch:product_selected',{product_id:card.getAttribute('data-product-id'),product_title:card.getAttribute('data-product-title')});
    });
  });
  document.querySelectorAll('form[role="search"]').forEach(function(searchForm){
    searchForm.addEventListener('submit',function(){
      var query=searchForm.querySelector('input[name="q"]');
      emit('hitch:search',{search_term:query ? query.value : ''});
    });
  });
  document.querySelectorAll('[data-drawer-checkout],button[name="checkout"]').forEach(function(checkoutControl){
    checkoutControl.addEventListener('click',function(){ emit('hitch:begin_checkout',{}); });
  });

  var root = document.querySelector('[data-pdp]');
  if(!root) return;

  var dataElement = root.querySelector('[data-product-json]');
  var variants = [];
  try{ variants = JSON.parse(dataElement.textContent || '[]'); }catch(error){ return; }
  var form = document.getElementById('HitchProductForm');
  var variantInput = root.querySelector('[data-variant-id]');
  var addButton = root.querySelector('[data-add-button]');
  var payment = root.querySelector('[data-payment-wrap]');
  var errorBox = root.querySelector('[data-product-error]');
  var optionGuidance = root.querySelector('[data-option-guidance]');
  var price = root.querySelector('[data-product-price]');
  var compare = root.querySelector('[data-product-compare]');
  var sale = root.querySelector('[data-product-sale]');
  var saleEnabled = root.getAttribute('data-sale-enabled') === 'true';
  var sticky = document.querySelector('[data-sticky-atc]');
  var stickyButton = sticky && sticky.querySelector('button');
  var stickyMeta = sticky && sticky.querySelector('[data-sticky-meta]');
  var selections = [];
  if(variantInput) variantInput.disabled = false;
  var groups = Array.prototype.slice.call(root.querySelectorAll('[data-option-group]'));

  function money(cents){
    var currency = root.getAttribute('data-currency') || 'USD';
    try{ return new Intl.NumberFormat(undefined,{style:'currency',currency:currency}).format((Number(cents)||0)/100); }
    catch(error){ return '$'+((Number(cents)||0)/100).toFixed(2); }
  }
  function variantOptions(variant){ return variant.options || [variant.option1,variant.option2,variant.option3].filter(Boolean); }
  function currentVariant(){
    if(!groups.length) return variants.filter(function(v){ return v.available; })[0] || variants[0];
    if(selections.some(function(value){ return !value; })) return null;
    return variants.find(function(variant){
      var opts = variantOptions(variant);
      return selections.every(function(value,index){ return opts[index] === value; });
    }) || null;
  }
  function missingOptionName(){
    var missingGroup = groups.find(function(group,index){ return !selections[index]; });
    return missingGroup ? (missingGroup.getAttribute('data-option-name') || 'option').trim() : '';
  }
  function selectionPrompt(includeAbove){
    var optionName = missingOptionName();
    if(!optionName) return includeAbove ? 'Select options above' : 'Select options';
    return 'Select '+optionName.toLowerCase()+(includeAbove?' above':'');
  }
  function canChoose(index,value){
    return variants.some(function(variant){
      if(!variant.available) return false;
      var opts = variantOptions(variant);
      if(opts[index] !== value) return false;
      return selections.every(function(selected,selectedIndex){
        return selectedIndex === index || !selected || opts[selectedIndex] === selected;
      });
    });
  }
  function updateOptionStates(){
    groups.forEach(function(group,index){
      group.querySelectorAll('[data-option-value]').forEach(function(button){
        var value = button.getAttribute('data-option-value');
        button.classList.toggle('is-selected',selections[index] === value);
        button.classList.toggle('is-impossible',!canChoose(index,value));
        button.setAttribute('aria-pressed',selections[index] === value ? 'true' : 'false');
      });
      var selectedText = group.querySelector('[data-selected-value]');
      if(selectedText) selectedText.textContent = selections[index] || 'Choose one';
    });
  }
  function updatePurchase(){
    var variant = currentVariant();
    updateOptionStates();
    if(variant){
      variantInput.value = variant.id;
      price.textContent = money(variant.price);
      if(saleEnabled && variant.compare_at_price && variant.compare_at_price > variant.price){
        compare.textContent = money(variant.compare_at_price);
        compare.hidden = false;
        var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
        sale.textContent = pct+'% off'; sale.hidden = false;
      }else{ compare.hidden = true; sale.hidden = true; }
      addButton.disabled = !variant.available;
      addButton.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if(optionGuidance) optionGuidance.hidden = true;
      if(payment) payment.hidden = !variant.available;
      if(stickyButton){ stickyButton.disabled = !variant.available; stickyButton.textContent = variant.available ? 'Add to cart' : 'Sold out'; }
      if(stickyMeta) stickyMeta.textContent = variant.title === 'Default Title' ? money(variant.price) : variant.title+' · '+money(variant.price);
      var mediaId = variant.featured_media && variant.featured_media.id;
      if(mediaId && window.innerWidth > 560){
        root.querySelectorAll('[data-gallery-item]').forEach(function(item){ item.classList.toggle('is-active',item.getAttribute('data-gallery-item') === String(mediaId)); });
        root.querySelectorAll('[data-gallery-thumb]').forEach(function(thumb){ thumb.classList.toggle('is-active',thumb.getAttribute('data-gallery-thumb') === String(mediaId)); });
      }
      try{ variantInput.dispatchEvent(new Event('change',{bubbles:true})); }catch(error){}
      try{ history.replaceState(null,'',location.pathname+'?variant='+variant.id); }catch(error){}
    }else{
      variantInput.value = '';
      addButton.disabled = true;
      addButton.textContent = selectionPrompt(true);
      if(optionGuidance){ optionGuidance.textContent = selectionPrompt(true)+' to continue.'; optionGuidance.hidden = false; }
      if(payment) payment.hidden = true;
      if(stickyButton){ stickyButton.disabled = false; stickyButton.textContent = selectionPrompt(false); }
      if(stickyMeta) stickyMeta.textContent = 'Select your options';
    }
  }
  groups.forEach(function(group,index){
    var isSize = group.getAttribute('data-option-name').toLowerCase().indexOf('size') !== -1;
    selections[index] = isSize ? '' : (group.getAttribute('data-initial-value') || '');
    group.addEventListener('click',function(event){
      var button = event.target.closest('[data-option-value]');
      if(!button || button.classList.contains('is-impossible')) return;
      selections[index] = button.getAttribute('data-option-value');
      if(errorBox) errorBox.classList.remove('is-visible');
      emit('hitch:variant_option_selected',{product_id:root.getAttribute('data-product-id'),option_name:group.getAttribute('data-option-name'),option_value:selections[index]});
      updatePurchase();
    });
  });
  updatePurchase();

  root.querySelectorAll('[data-gallery-thumb]').forEach(function(button){
    button.addEventListener('click',function(){
      var id = button.getAttribute('data-gallery-thumb');
      root.querySelectorAll('[data-gallery-item]').forEach(function(item){ item.classList.toggle('is-active',item.getAttribute('data-gallery-item') === id); });
      root.querySelectorAll('[data-gallery-thumb]').forEach(function(thumb){ thumb.classList.toggle('is-active',thumb === button); });
    });
  });

  function showOptionError(){
    if(errorBox){ errorBox.textContent = selectionPrompt(true)+' before adding this style.'; errorBox.classList.add('is-visible'); }
    var firstMissing = groups.find(function(group,index){ return !selections[index]; });
    if(firstMissing) firstMissing.scrollIntoView({behavior:'smooth',block:'center'});
  }
  function addToCart(){
    var variant = currentVariant();
    if(!variant){ showOptionError(); return; }
    var buttons = [addButton,stickyButton].filter(Boolean);
    buttons.forEach(function(button){ button.disabled=true; button.textContent='Adding…'; });
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/')+'cart/add.js',{
      method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[{id:Number(variant.id),quantity:1}]})
    }).then(function(response){ if(!response.ok) return response.json().then(function(body){ throw new Error(body.description || 'Unable to add this item.'); }); return response.json(); })
      .then(function(){
        emit('hitch:add_to_cart',{product_id:root.getAttribute('data-product-id'),variant_id:variant.id,value:variant.price/100});
        buttons.forEach(function(button){ button.textContent='Added ✓'; });
        if(window.HitchCartDrawer) window.HitchCartDrawer.open(); else window.location.href='/cart';
        window.setTimeout(function(){ buttons.forEach(function(button){ button.disabled=false; button.textContent='Add to cart'; }); },1500);
      }).catch(function(error){
        if(errorBox){ errorBox.textContent=error.message; errorBox.classList.add('is-visible'); }
        buttons.forEach(function(button){ button.disabled=false; button.textContent='Add to cart'; });
      });
  }
  if(form) form.addEventListener('submit',function(event){ event.preventDefault(); addToCart(); });
  if(stickyButton) stickyButton.addEventListener('click',function(){
    if(!currentVariant()){ root.querySelector('.pdp-buy').scrollIntoView({behavior:'smooth',block:'start'}); showOptionError(); return; }
    addToCart();
  });
  if(sticky && addButton && 'IntersectionObserver' in window){
    var observer = new IntersectionObserver(function(entries){ sticky.classList.toggle('is-visible',!entries[0].isIntersecting && window.innerWidth < 821); },{threshold:.1});
    observer.observe(addButton);
  }
  emit('hitch:product_viewed',{product_id:root.getAttribute('data-product-id'),product_title:root.getAttribute('data-product-title')});
})();
